// src/components/modalForm/ModalContainer.js
import React, { useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ModalContainer.css';
import './ModalForm.css';
import './ModalTheme.css';
import { useModalStack } from '../../contexts/geral/ModalStackContext';
import { ModalFormContext } from './ModalFormContext';
import useModalFormFocus from './UseModalFormFocus';

const ModalContainer = ({ show, children, largura = '500px', zIndex = 1050, contentClassName = '', variant = 'legacy', onHide }) => {
  const modalLayer = useModalStack(show, zIndex);
  const modalRef = useRef(null);
  const titleId = useId();
  const [activeTabId, setActiveTabId] = useState(null);
  const standard = variant === 'cadastro' || variant === 'busca';
  const handleKeyDown = useModalFormFocus({ show, enabled: standard, isTopModal: modalLayer.isTopModal, modalRef, onHide });

  if (!show) {
    return null;
  }

  return createPortal(
    <div
      ref={modalRef}
      className={`modal fade show d-block${standard ? ` modal-form modal-form-${variant}` : ''}`}
      tabIndex="-1"
      role="dialog"
      onKeyDown={handleKeyDown}
      aria-labelledby={standard ? titleId : undefined}
      aria-modal={modalLayer.isTopModal}
      inert={modalLayer.isTopModal ? undefined : true}
      data-modal-stack-id={modalLayer.id}
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: modalLayer.zIndex }}
    >
      <div
        className="modal-dialog"
        role="document"
        style={{ maxWidth: largura, width: standard ? 'calc(100% - 16px)' : '90vw' }} // largura will be overridden by CSS on smaller screens
      >
        <div className={`modal-content ${contentClassName}`.trim()}>
          <ModalFormContext.Provider value={{ variant, titleId, tabPanelId: `${titleId}-panel`, activeTabId, setActiveTabId }}>
            {children}
          </ModalFormContext.Provider>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ModalContainer;
